module.exports = __webpack_public_path__ + "static/img/img-home-co-10.1d02e9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-10.png
// module id = 3Byq
// module chunks = 1